import { SearchCustomers, SearchCustomersToken } from "$src/application/customers/queries/SearchCustomers";
import { PagedResult } from "$src/domain/core/PagedResult";
import { CustomerSummary } from "$src/domain/customers/CustomerSummary";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function fetchSearchCustomers(groupStoreId: number, pattern: string, pageNumber: number, pageSize: number): Promise<PagedResult<CustomerSummary>> {
    if( pattern.length > 0 )
    {
        const query = container.resolve<SearchCustomers>(SearchCustomersToken);
        return query.execute(groupStoreId, pattern, pageNumber, pageSize);
    }
    
    return new PagedResult<CustomerSummary>();
}

export function useSearchCustomers(groupStoreId: number, pattern: string, pageNumber: number, pageSize: number) {

    return useQuery<PagedResult<CustomerSummary>, Error>({
        queryKey: ['search-customers', pattern, pageNumber, pageSize],
        queryFn: () => fetchSearchCustomers(groupStoreId, pattern, pageNumber, pageSize),
        staleTime: 30000,
        cacheTime: 60000,
    });
}
